export default "__VITE_ASSET__fcf186ad__"